import React from 'react';
import Cookies from 'js-cookie';
import {
	Card, Row, Col, Form, DatePicker, Select, Input,
	Button, Tag, Spin, Modal, message, Tabs, Collapse,
} from 'antd';
import {
	SearchOutlined, PrinterOutlined, CopyOutlined,
	ExclamationCircleOutlined, ReloadOutlined, TableOutlined,
	CalendarOutlined, BarChartOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import {
	initHandler, ajaxViewHandler, ajaxHandler, setConfig,
} from "../../store/actions";
import Config from '../../Config';
import { Helmet } from "react-helmet";
import moment from "moment";
import '../../assets/laporan.css';

const { TabPane } = Tabs;
const { Panel } = Collapse;

const configClass = {
	title: 'LAPORAN PENGGUNAAN NOTICE',
	apiUrl: {
		data: 'laporan/api/notice/penggunaan-rusak/',
		rekap: 'laporan/api/notice/rekap-penggunaan/',
		upt: "pegawai/api/upt/",
		kabupaten: "master/api/kabupaten/",
	},
	breadCrumb: ['Laporan', 'Penggunaan Notice'],
}

const config = new Config();

class LapPenggunaanNoticeRusak extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.config = new Config();
		this.state = {
			activeTab: 'detail',
			isMobile: window.innerWidth <= 768,

			loading: false,
			data: null,
			err: false,

			loadingUpt: false,
			listUpt: [],
			loadingKabupaten: false,
			listKabupaten: [],
			kabupaten_id: "",
			filter: "",

			showWarningModal: false,
			redNoticesList: [],

			// Rekap Harian - kabupaten/upt scope sendiri (independen dari tab Detail)
			rh_kabupaten_id: "",
			rh_upt_id: undefined,
			rh_listUpt: [],
			rh_loadingUpt: false,
			rh_tanggalMulai: moment(),
			rh_tanggalSampai: moment(),
			rh_loading: false,
			rh_data: null,

			// Rekap Bulanan - sama polanya, tanggal dikunci ke 1 bulan penuh
			rb_kabupaten_id: "",
			rb_upt_id: undefined,
			rb_listUpt: [],
			rb_loadingUpt: false,
			rb_bulan: moment(),
			rb_loading: false,
			rb_data: null,
		}
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.getMasterList({
			destination: {
				stateProgressName: "loadingKabupaten",
				endPoint: configClass.apiUrl.kabupaten,
				stateDestination: "listKabupaten",
			},
		});
		this.initKabupatenFromCookie();
		this._initScopeFromCookie('rh');
		this._initScopeFromCookie('rb');
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	// Sama seperti initKabupatenFromCookie, tapi generik utk scope tab Rekap
	// Harian/Bulanan (prefix 'rh'/'rb') yang tidak memakai Form.Item terpisah.
	_initScopeFromCookie(prefix) {
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + '_upt');
			if (!rawCookie) return;
			const parsed = JSON.parse(decodeURIComponent(rawCookie));
			const kabupatenId = parsed.kabupaten;
			if (!kabupatenId) return;
			this.setState({ [`${prefix}_kabupaten_id`]: kabupatenId });
			this.getMasterList({
				destination: {
					stateProgressName: `${prefix}_loadingUpt`,
					endPoint: configClass.apiUrl.upt + "?kabupaten=" + kabupatenId,
					stateDestination: `${prefix}_listUpt`,
				},
			});
		} catch (err) {
			console.warn('Cookie _upt tidak valid:', err);
		}
	}

	initKabupatenFromCookie() {
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + '_upt');
			if (!rawCookie) return;
			const parsed = JSON.parse(decodeURIComponent(rawCookie));
			const kabupatenId = parsed.kabupaten;
			if (!kabupatenId) return;
			this.setState({ kabupaten_id: kabupatenId });
			setTimeout(() => {
				if (this.formRef.current) {
					this.formRef.current.setFieldsValue({ kabupaten: kabupatenId });
				}
			}, 0);
			this.getMasterList({
				destination: {
					stateProgressName: "loadingUpt",
					endPoint: configClass.apiUrl.upt + "?kabupaten=" + kabupatenId,
					stateDestination: "listUpt",
				},
			});
		} catch (err) {
			console.warn('Cookie _upt tidak valid:', err);
		}
	}

	isKabupatenLocked() {
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + '_upt');
			if (!rawCookie) return false;
			const parsed = JSON.parse(decodeURIComponent(rawCookie));
			return Boolean(parsed.kabupaten && parsed.id);
		} catch (err) {
			return false;
		}
	}

	async getMasterList(rule) {
		const destination = rule.destination;
		this.setState({ [destination.stateProgressName]: true });
		this.props.ajaxViewHandler("get", destination.endPoint)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					if (data.count !== undefined) {
						this.setState({ [destination.stateDestination]: data });
					} else if (data.results !== undefined) {
						this.setState({ [destination.stateDestination]: data.results });
					} else {
						this.setState({ [destination.stateDestination]: Array.isArray(data) ? data : [data] });
					}
				}
				this.setState({ [destination.stateProgressName]: false });
			})
			.catch(() => {
				this.setState({ [destination.stateProgressName]: false });
			});
	}

	generateSelect(stateName, url, key, value, keyDisplay = "") {
		return this.state["loading" + stateName] ? (
			<img src={process.env.PUBLIC_URL + "/loading_crop.gif"} height="40" />
		) : (
			<Select
				showSearch
				placeholder={"Cari / Pilih " + stateName}
				disabled={stateName === "Kabupaten" && this.isKabupatenLocked()}
				optionFilterProp="children"
				onSearch={(val) => {
					let urls = url + "?search=" + val;
					if (stateName === "Upt") {
						urls = `${url}?kabupaten=${this.state.kabupaten_id}&search=${val}`;
					}
					this.getMasterList({
						destination: {
							stateProgressName: "loading" + stateName + "_searching",
							endPoint: urls,
							stateDestination: "list" + stateName,
						},
					});
				}}
				allowClear
				style={{ width: "100%" }}
				onChange={(val) => {
					if (stateName === "Kabupaten") {
						this.setState({ kabupaten_id: val }, () => {
							this.getMasterList({
								destination: {
									stateProgressName: "loadingUpt",
									endPoint: configClass.apiUrl.upt + "?kabupaten=" + val,
									stateDestination: "listUpt",
								},
							});
						});
					}
				}}
			>
				{this.state["loading" + stateName + "_searching"] && (
					<Select.Option value=""><Spin size="small" /></Select.Option>
				)}
				{(this.state["list" + stateName].count !== undefined
					? this.state["list" + stateName].results
					: this.state["list" + stateName]
				).map((item) => (
					<Select.Option value={item[key]} key={item[key]}>
						{keyDisplay === "" ? item[key] + " - " + item[value] : item[keyDisplay] + " - " + item[value]}
					</Select.Option>
				))}
			</Select>
		);
	}

	// Sama seperti generateSelect, tapi state-nya dinamis per prefix ('rh'/'rb')
	// supaya tab Rekap Harian dan Rekap Bulanan bisa punya scope Kabupaten/UPT
	// sendiri-sendiri, independen dari tab Detail (yang tetap pakai generateSelect
	// + formRef seperti semula, tidak disentuh).
	_generateScopeSelect(prefix, stateName, url, key, value, keyDisplay = "") {
		const isKabupaten = stateName === "Kabupaten";
		const listKey = isKabupaten ? "listKabupaten" : `${prefix}_listUpt`;
		const loadingKey = isKabupaten ? "loadingKabupaten" : `${prefix}_loadingUpt`;
		const idKey = isKabupaten ? `${prefix}_kabupaten_id` : `${prefix}_upt_id`;
		const list = this.state[listKey] || [];
		const items = list.count !== undefined ? list.results : list;

		return this.state[loadingKey] ? (
			<img src={process.env.PUBLIC_URL + "/loading_crop.gif"} height="40" />
		) : (
			<Select
				showSearch
				placeholder={"Cari / Pilih " + stateName}
				disabled={isKabupaten && this.isKabupatenLocked()}
				optionFilterProp="children"
				value={this.state[idKey] || undefined}
				allowClear
				style={{ width: "100%" }}
				onSearch={(val) => {
					let urls = url + "?search=" + val;
					if (!isKabupaten) urls = `${url}?kabupaten=${this.state[`${prefix}_kabupaten_id`]}&search=${val}`;
					this.getMasterList({
						destination: {
							stateProgressName: `${prefix}_loading${stateName}_searching`,
							endPoint: urls,
							stateDestination: listKey,
						},
					});
				}}
				onChange={(val) => {
					this.setState({ [idKey]: val }, () => {
						if (isKabupaten) {
							this.setState({ [`${prefix}_upt_id`]: undefined, [`${prefix}_listUpt`]: [] }, () => {
								this.getMasterList({
									destination: {
										stateProgressName: `${prefix}_loadingUpt`,
										endPoint: configClass.apiUrl.upt + "?kabupaten=" + val,
										stateDestination: `${prefix}_listUpt`,
									},
								});
							});
						}
					});
				}}
			>
				{items.map((item) => (
					<Select.Option value={item[key]} key={item[key]}>
						{keyDisplay === "" ? item[key] + " - " + item[value] : item[keyDisplay] + " - " + item[value]}
					</Select.Option>
				))}
			</Select>
		);
	}

	handleSubmit = (values) => {
		let filter = "";
		for (const key in values) {
			if (key.endsWith('_picker')) continue;
			if (values[key] !== undefined && values[key] !== "") {
				filter += (filter === "" ? "?" : "&") + key + "=" + values[key];
			}
		}
		this.setState({ filter, data: null });
		this.getData(filter);
	}

	async getData(filter) {
		message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
		this.setState({ loading: true, err: false, data: null });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + filter)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({ loading: false, data, err: false });
				} else {
					this.setState({ loading: false, data: null, err: true });
					message.error({ content: 'Gagal memuat laporan', duration: 2, key: 'toast' });
				}
			}).catch(() => {
				this.setState({ loading: false, data: null, err: true });
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	_buildScopeFilter(prefix) {
		const uptId = this.state[`${prefix}_upt_id`];
		const kabupatenId = this.state[`${prefix}_kabupaten_id`];
		if (uptId) return "?upt=" + uptId;
		if (kabupatenId) return "?kabupaten=" + kabupatenId;
		return "?";
	}

	getRekapHarian = () => {
		const { rh_tanggalMulai, rh_tanggalSampai } = this.state;
		const mulai = (rh_tanggalMulai || moment()).format('DD-MM-YYYY');
		const sampai = (rh_tanggalSampai || rh_tanggalMulai || moment()).format('DD-MM-YYYY');
		const filter = this._buildScopeFilter('rh') + `&mulai_dari=${mulai}&sampai_dengan=${sampai}`;

		message.loading({ content: 'Menampilkan rekap harian...', duration: 0, key: 'toastRh' });
		this.setState({ rh_loading: true, rh_data: null });
		this.props.ajaxViewHandler('get', configClass.apiUrl.rekap + filter)
			.then(() => {
				if (this.props.isSuccess) {
					message.destroy('toastRh');
					this.setState({ rh_loading: false, rh_data: this.props.responseMsg });
				} else {
					this.setState({ rh_loading: false, rh_data: null });
					message.error({ content: 'Gagal memuat rekap harian', duration: 2, key: 'toastRh' });
				}
			}).catch(() => {
				this.setState({ rh_loading: false, rh_data: null });
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toastRh' });
			});
	}

	getRekapBulanan = () => {
		const bulan = this.state.rb_bulan || moment();
		const mulai = bulan.clone().startOf('month').format('DD-MM-YYYY');
		const sampai = bulan.clone().endOf('month').format('DD-MM-YYYY');
		const filter = this._buildScopeFilter('rb') + `&mulai_dari=${mulai}&sampai_dengan=${sampai}`;

		message.loading({ content: 'Menampilkan rekap bulanan...', duration: 0, key: 'toastRb' });
		this.setState({ rb_loading: true, rb_data: null });
		this.props.ajaxViewHandler('get', configClass.apiUrl.rekap + filter)
			.then(() => {
				if (this.props.isSuccess) {
					message.destroy('toastRb');
					this.setState({ rb_loading: false, rb_data: this.props.responseMsg });
				} else {
					this.setState({ rb_loading: false, rb_data: null });
					message.error({ content: 'Gagal memuat rekap bulanan', duration: 2, key: 'toastRb' });
				}
			}).catch(() => {
				this.setState({ rb_loading: false, rb_data: null });
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toastRb' });
			});
	}

	getGlobalCount() {
		if (!this.state.data) return {};
		const globalCount = {};
		this.state.data.data.forEach(g => g.nomor_notice_terpakai.forEach(n => {
			globalCount[n.nomor_notice] = (globalCount[n.nomor_notice] || 0) + 1;
		}));
		return globalCount;
	}

	getRedNotices() {
		if (!this.state.data) return [];
		const globalCount = this.getGlobalCount();
		const red = [];
		this.state.data.data.forEach(g => {
			const batalSet = new Set(g.batal_rusak.map(k => k.nomor_notice));
			g.nomor_notice_terpakai.forEach(n => {
				if (n.rusak || batalSet.has(n.nomor_notice) || globalCount[n.nomor_notice] > 1) {
					red.push({ nopol: g.nomor_polisi, nomor_notice: n.nomor_notice });
				}
			});
		});
		return red;
	}

	handlePrintSection = (selector) => {
		const section = document.querySelector(selector);
		if (!section) return;
		const parent = section.parentNode;
		const nextSib = section.nextSibling;
		section.style.display = 'block';
		document.body.appendChild(section);
		const siblings = Array.from(document.body.children).filter(el => el !== section);
		siblings.forEach(el => { el.style.display = 'none'; });
		window.print();
		siblings.forEach(el => { el.style.display = ''; });
		section.style.display = 'none';
		if (nextSib) parent.insertBefore(section, nextSib);
		else parent.appendChild(section);
	}

	handlePrint = () => this.handlePrintSection('.notice-penggunaan-print-section');

	checkAndPrint = () => {
		const red = this.getRedNotices();
		if (red.length > 0) {
			this.setState({ showWarningModal: true, redNoticesList: red });
			return;
		}
		this.handlePrint();
	}

	// Isi tabel utk satu UPT (dipakai dalam mode flat maupun di dalam Collapse.Panel).
	_renderRekapUptTable(u, rp) {
		return (
			<table className="laporan-table" border="1" cellPadding="5" style={{ width: '100%' }}>
				<thead>
					<tr>
						<th>Tanggal</th><th>Kode Notice</th><th>Nomor Awal</th><th>Nomor Akhir</th>
						<th>Terpakai</th><th>Rusak</th><th>Batal</th><th>Total</th>
					</tr>
				</thead>
				<tbody>
					{u.rows.map((r, ri) => (
						<tr key={ri}>
							<td className="teks-tengah">{r.tanggal}</td>
							<td className="teks-tengah">{r.kode_notice || '-'}</td>
							<td className="teks-tengah">{rp(r.nomor_awal)}</td>
							<td className="teks-tengah">{rp(r.nomor_akhir)}</td>
							<td className="teks-kanan">{r.terpakai}</td>
							<td className="teks-kanan" style={r.rusak > 0 ? { color: 'red', fontWeight: 600 } : undefined}>{r.rusak}</td>
							<td className="teks-kanan">{r.batal}</td>
							<td className="teks-kanan" style={{ fontWeight: 600 }}>{r.total}</td>
						</tr>
					))}
				</tbody>
				<tfoot>
					<tr style={{ background: '#f0f4ff', fontWeight: 700 }}>
						<td colSpan={4} className="teks-kanan">SUBTOTAL {(u.upt_nama || '-').toUpperCase()}</td>
						<td className="teks-kanan">{u.total_upt.terpakai}</td>
						<td className="teks-kanan">{u.total_upt.rusak}</td>
						<td className="teks-kanan">{u.total_upt.batal}</td>
						<td className="teks-kanan">{u.total_upt.total}</td>
					</tr>
				</tfoot>
			</table>
		);
	}

	// Tabel rekap. `collapsible=true` (tampilan layar, kalau UPT > 1) bungkus
	// tiap UPT dalam Collapse supaya bisa expand/collapse sendiri-sendiri.
	// Versi cetak/PDF selalu panggil collapsible=false (kertas resmi, semua
	// section harus tampil penuh, tidak ada yang disembunyikan).
	_renderRekapTable(data, collapsible = false) {
		if (!data) return null;
		const NAVY = '#0f2847';
		const rp = (v) => (v ?? '-');

		const grandTotalBar = data.upt_list.length > 1 && (
			<div style={{
				padding: 12, background: NAVY, color: '#fff', borderRadius: 8,
				display: 'flex', justifyContent: 'space-between', fontWeight: 700, flexWrap: 'wrap', gap: 8, marginTop: 8,
			}}>
				<span>GRAND TOTAL</span>
				<span>Terpakai: {data.grand_total.terpakai} · Rusak: {data.grand_total.rusak} · Batal: {data.grand_total.batal} · Total: {data.grand_total.total}</span>
			</div>
		);
		const emptyState = data.upt_list.length === 0 && (
			<div style={{ textAlign: 'center', padding: 24, color: '#aaa' }}>Tidak ada data pada periode/filter ini.</div>
		);

		if (collapsible && data.upt_list.length > 1) {
			return (
				<div>
					<Collapse
						bordered={false}
						className="rekap-upt-collapse"
					>
						{data.upt_list.map((u, ui) => (
							<Panel
								key={ui}
								style={{ marginBottom: 8, border: '1px solid #e2e8f0', borderRadius: 10, overflow: 'hidden' }}
								header={<span style={{ fontWeight: 700, color: NAVY }}>{(u.upt_nama || '-').toUpperCase()}</span>}
								extra={<Tag color="blue" style={{ margin: 0 }}>Total {u.total_upt.total}</Tag>}
							>
								{this._renderRekapUptTable(u, rp)}
							</Panel>
						))}
					</Collapse>
					{grandTotalBar}
					{emptyState}
				</div>
			);
		}

		return (
			<div>
				{data.upt_list.map((u, ui) => (
					<div key={ui} style={{ marginBottom: 20 }}>
						<div style={{ fontWeight: 700, color: NAVY, marginBottom: 6 }}>{(u.upt_nama || '-').toUpperCase()}</div>
						{this._renderRekapUptTable(u, rp)}
					</div>
				))}
				{grandTotalBar}
				{emptyState}
			</div>
		);
	}

	// Versi cetak/PDF - tiap UPT jadi halaman kertas sendiri (class "kertas-laporan
	// pagebreak", konvensi page-break-after:always yang sudah dipakai laporan
	// lain di aplikasi ini - lihat laporan.css), lengkap dengan kop & judul
	// diulang di tiap halaman supaya tiap lembar tetap jelas identitasnya
	// kalau dipisah/diarsipkan sendiri-sendiri per UPT.
	_renderRekapPrintPerUpt(data, judulCetak) {
		const rp = (v) => (v ?? '-');
		const header = (uptNama) => (
			<div style={{ textAlign: 'center', marginBottom: 6 }}>
				<div style={{ fontSize: 13, fontWeight: 'bold' }}>BADAN PENDAPATAN DAERAH</div>
				{uptNama && <div style={{ fontSize: 13, fontWeight: 'bold' }}>{uptNama.toUpperCase()}</div>}
				<div style={{ fontSize: 14, fontWeight: 'bold', textDecoration: 'underline', marginTop: 4 }}>
					{judulCetak}
				</div>
				<div style={{ fontSize: 12, marginTop: 4 }}>
					Periode: {data.mulai_dari} s.d. {data.sampai_dengan}
				</div>
			</div>
		);

		if (data.upt_list.length === 0) {
			return (
				<div className="kertas-laporan">
					{header()}
					<div style={{ textAlign: 'center', padding: 24, color: '#aaa' }}>Tidak ada data pada periode/filter ini.</div>
				</div>
			);
		}

		return (
			<>
				{data.upt_list.map((u, ui) => (
					<div key={ui} className={ui < data.upt_list.length - 1 ? 'kertas-laporan pagebreak' : 'kertas-laporan'}>
						{header(u.upt_nama)}
						{this._renderRekapUptTable(u, rp)}
					</div>
				))}
			</>
		);
	}

	// Isi kartu-kartu utk satu UPT (dipakai flat maupun di dalam Collapse.Panel).
	_renderRekapUptCards(u) {
		const NAVY = '#0f2847';
		const activeRows = u.rows.filter(r => r.total > 0);
		const emptyCount = u.rows.length - activeRows.length;
		return (
			<div>
				{activeRows.length === 0 ? (
					<div style={{ textAlign: 'center', padding: 16, color: '#aaa', fontSize: 12, border: '1px dashed #e2e8f0', borderRadius: 10 }}>
						Tidak ada aktivitas pada periode ini
					</div>
				) : (
					activeRows.map((r, ri) => (
						<div key={ri} style={{
							border: '1px solid #e8edf5', borderRadius: 10, marginBottom: 8, overflow: 'hidden',
							boxShadow: '0 1px 4px rgba(15,40,71,0.05)',
						}}>
							<div style={{
								background: 'linear-gradient(135deg, #0f284709, #1e4d8a0d)', padding: '8px 12px',
								display: 'flex', justifyContent: 'space-between', alignItems: 'center',
								borderBottom: '1px solid #e8edf5',
							}}>
								<span style={{ fontWeight: 700, fontSize: 12.5, color: NAVY }}>{r.tanggal}</span>
								<Tag color="blue" style={{ margin: 0, fontSize: 11 }}>Kode {r.kode_notice || '-'}</Tag>
							</div>
							<div style={{ padding: '10px 12px' }}>
								<div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>
									Nomor: {r.nomor_awal ?? '-'} – {r.nomor_akhir ?? '-'}
								</div>
								<div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6, textAlign: 'center' }}>
									{[
										{ label: 'Terpakai', val: r.terpakai, color: '#1e4d8a' },
										{ label: 'Rusak', val: r.rusak, color: r.rusak > 0 ? '#cf1322' : '#94a3b8' },
										{ label: 'Batal', val: r.batal, color: '#94a3b8' },
										{ label: 'Total', val: r.total, color: NAVY, bold: true },
									].map((f, fi) => (
										<div key={fi}>
											<div style={{ fontSize: 9, color: '#94a3b8', textTransform: 'uppercase', fontWeight: 600 }}>{f.label}</div>
											<div style={{ fontSize: 14, fontWeight: f.bold ? 800 : 700, color: f.color }}>{f.val}</div>
										</div>
									))}
								</div>
							</div>
						</div>
					))
				)}
				{emptyCount > 0 && (
					<div style={{ textAlign: 'center', padding: '6px 0', fontSize: 11, color: '#aaa', fontStyle: 'italic' }}>
						{emptyCount} hari lainnya tidak ada aktivitas
					</div>
				)}
				<div style={{
					display: 'flex', justifyContent: 'space-between', padding: '8px 12px',
					background: '#f0f4ff', borderRadius: 8, fontSize: 11.5, fontWeight: 700, color: NAVY, marginTop: 4, flexWrap: 'wrap', gap: 4,
				}}>
					<span>Subtotal</span>
					<span>T:{u.total_upt.terpakai} R:{u.total_upt.rusak} B:{u.total_upt.batal} = {u.total_upt.total}</span>
				</div>
			</div>
		);
	}

	// Versi mobile dari _renderRekapTable - kartu ringkas per hari yang ADA
	// aktivitas (hari kosong dirangkum jadi satu baris kecil, bukan satu
	// kartu kosong per hari - supaya rekap bulanan tidak jadi puluhan kartu
	// kosong yang harus discroll di layar HP). Versi cetak/PDF tetap pakai
	// _renderRekapTable (tabel penuh, termasuk hari kosong). Kalau UPT > 1,
	// tiap UPT dibungkus Collapse supaya bisa expand/collapse sendiri-sendiri.
	_renderRekapCards(data) {
		const NAVY = '#0f2847';

		const grandTotalBar = data.upt_list.length > 1 && (
			<div style={{
				padding: 12, background: NAVY, color: '#fff', borderRadius: 8,
				display: 'flex', flexDirection: 'column', gap: 4, fontWeight: 700, fontSize: 12, marginTop: 8,
			}}>
				<span>GRAND TOTAL</span>
				<span>Terpakai: {data.grand_total.terpakai} · Rusak: {data.grand_total.rusak} · Batal: {data.grand_total.batal} · Total: {data.grand_total.total}</span>
			</div>
		);
		const emptyState = data.upt_list.length === 0 && (
			<div style={{ textAlign: 'center', padding: 24, color: '#aaa' }}>Tidak ada data pada periode/filter ini.</div>
		);

		if (data.upt_list.length > 1) {
			return (
				<div>
					<Collapse
						bordered={false}
						className="rekap-upt-collapse"
					>
						{data.upt_list.map((u, ui) => (
							<Panel
								key={ui}
								style={{ marginBottom: 8, border: '1px solid #e2e8f0', borderRadius: 10, overflow: 'hidden' }}
								header={<span style={{ fontWeight: 700, color: NAVY, fontSize: 13 }}>{(u.upt_nama || '-').toUpperCase()}</span>}
								extra={<Tag color="blue" style={{ margin: 0, fontSize: 11 }}>{u.total_upt.total}</Tag>}
							>
								{this._renderRekapUptCards(u)}
							</Panel>
						))}
					</Collapse>
					{grandTotalBar}
					{emptyState}
				</div>
			);
		}

		return (
			<div>
				{data.upt_list.map((u, ui) => (
					<div key={ui} style={{ marginBottom: 16 }}>
						<div style={{ fontWeight: 700, color: NAVY, fontSize: 13, marginBottom: 8 }}>{(u.upt_nama || '-').toUpperCase()}</div>
						{this._renderRekapUptCards(u)}
					</div>
				))}
				{grandTotalBar}
				{emptyState}
			</div>
		);
	}

	fmtTanggal() {
		const { data } = this.state;
		if (!data) return '-';
		if (data.tanggal_sampai) return `${data.tanggal_mulai} s.d. ${data.tanggal_sampai}`;
		return data.tanggal_mulai || '-';
	}

	// Render filter + hasil utk satu tab rekap (harian/bulanan) - beda antar
	// keduanya cuma di kontrol tanggal (dateMode 'range' vs 'month').
	_renderRekapTab(prefix, { dateMode, loading, data, onProses, printSelector, judulCetak }) {
		const NAVY = '#0f2847';
		const hasData = data !== null;
		const isMobile = this.state.isMobile;
		return (
			<div>
				<Card
					style={{ borderRadius: 14, border: 'none', boxShadow: '0 4px 20px rgba(15,40,71,0.08)', marginBottom: 16 }}
					bodyStyle={{ padding: '20px 28px' }}
				>
					<Row gutter={[16, 12]} align="bottom">
						<Col xs={24} sm={12} md={6}>
							<div style={{ fontSize: 11, fontWeight: 600, color: '#475569', marginBottom: 6, textTransform: 'uppercase' }}>Kabupaten</div>
							{this._generateScopeSelect(prefix, "Kabupaten", configClass.apiUrl.kabupaten, "id", "name")}
						</Col>
						<Col xs={24} sm={12} md={6}>
							<div style={{ fontSize: 11, fontWeight: 600, color: '#475569', marginBottom: 6, textTransform: 'uppercase' }}>UPT</div>
							{this._generateScopeSelect(prefix, "Upt", configClass.apiUrl.upt, "id", "nama", "id")}
						</Col>
						{dateMode === 'range' ? (
							<>
								<Col xs={12} sm={6} md={4}>
									<div style={{ fontSize: 11, fontWeight: 600, color: '#475569', marginBottom: 6, textTransform: 'uppercase' }}>Dari Tanggal</div>
									<DatePicker
										placeholder="dd-mm-yyyy"
										format="DD-MM-YYYY"
										style={{ width: "100%" }}
										value={this.state[`${prefix}_tanggalMulai`]}
										onChange={(d) => this.setState({ [`${prefix}_tanggalMulai`]: d })}
										allowClear={false}
									/>
								</Col>
								<Col xs={12} sm={6} md={4}>
									<div style={{ fontSize: 11, fontWeight: 600, color: '#475569', marginBottom: 6, textTransform: 'uppercase' }}>Sampai Tanggal</div>
									<DatePicker
										placeholder="dd-mm-yyyy"
										format="DD-MM-YYYY"
										style={{ width: "100%" }}
										value={this.state[`${prefix}_tanggalSampai`]}
										onChange={(d) => this.setState({ [`${prefix}_tanggalSampai`]: d })}
										allowClear={false}
									/>
								</Col>
							</>
						) : (
							<Col xs={24} sm={12} md={6}>
								<div style={{ fontSize: 11, fontWeight: 600, color: '#475569', marginBottom: 6, textTransform: 'uppercase' }}>Bulan</div>
								<DatePicker.MonthPicker
									placeholder="pilih bulan"
									format="MMMM YYYY"
									style={{ width: "100%" }}
									value={this.state.rb_bulan}
									onChange={(d) => this.setState({ rb_bulan: d || moment() })}
									allowClear={false}
								/>
							</Col>
						)}
						<Col xs={hasData ? 12 : 24} sm="auto">
							<Button
								type="primary"
								block={isMobile}
								loading={loading}
								icon={<SearchOutlined />}
								style={{ background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', border: 'none', borderRadius: 8, fontWeight: 600, height: 38 }}
								onClick={onProses}
							>
								Proses
							</Button>
						</Col>
						{hasData && (
							<Col xs={12} sm="auto">
								<Button
									block={isMobile}
									icon={<PrinterOutlined />}
									style={{ borderRadius: 8, height: 38, borderColor: NAVY, color: NAVY }}
									onClick={() => this.handlePrintSection(printSelector)}
								>
									{isMobile ? 'Cetak' : 'Cetak PDF'}
								</Button>
							</Col>
						)}
					</Row>
				</Card>

				{loading && (
					<Card style={{ borderRadius: 14, border: 'none', boxShadow: '0 4px 20px rgba(15,40,71,0.08)', textAlign: 'center', padding: 48 }}>
						<Spin size="large" />
						<div style={{ marginTop: 16, color: '#888' }}>Memuat rekap...</div>
					</Card>
				)}

				{hasData && !loading && (
					<Card style={{ borderRadius: 14, border: 'none', boxShadow: '0 4px 20px rgba(15,40,71,0.08)' }} bodyStyle={{ padding: isMobile ? '14px 12px' : 24 }}>
						<div style={{ fontSize: 12, color: '#888', marginBottom: 12 }}>
							Periode: <strong>{data.mulai_dari}</strong> s.d. <strong>{data.sampai_dengan}</strong>
						</div>
						{isMobile ? (
							this._renderRekapCards(data)
						) : (
							<div style={{ overflowX: 'auto' }}>
								{this._renderRekapTable(data, true)}
							</div>
						)}
					</Card>
				)}

				{/* ── EMBEDDED PRINT SECTION (per UPT, 1 UPT = 1 halaman) ── */}
				{hasData && (
					<div className={printSelector.replace('.', '')} style={{ display: 'none' }}>
						{this._renderRekapPrintPerUpt(data, judulCetak)}
					</div>
				)}
			</div>
		);
	}

	render() {
		const { loading, data, showWarningModal, redNoticesList, isMobile, activeTab } = this.state;
		const hasData = data !== null;
		const globalCount = this.getGlobalCount();
		const rekap = data?.rekap || { terpakai: 0, batal: 0, rusak: 0, jumlah: 0 };
		const ttd = data?.ttd || {};
		const kabupatenNama = (data?.kabupaten_nama || '').toUpperCase();
		const uptNama = (data?.upt_nama || '').toUpperCase();

		return (
			<div style={{ padding: '0 0 24px' }}>
				<Helmet>
					<title>{configClass.title + " | " + config.get_site_info().name}</title>
					<style>{`
						.penggunaan-notice-tabs.ant-tabs > .ant-tabs-nav {
							margin-bottom: 16px;
						}
						.penggunaan-notice-tabs.ant-tabs > .ant-tabs-nav::before {
							border-bottom: none;
						}
						.penggunaan-notice-tabs .ant-tabs-nav-list {
							gap: 8px;
						}
						.penggunaan-notice-tabs .ant-tabs-tab {
							background: #fff;
							border: 1px solid #e2e8f0 !important;
							border-radius: 10px !important;
							padding: 10px 20px !important;
							margin: 0 !important;
							transition: all 0.2s ease;
							box-shadow: 0 1px 4px rgba(15,40,71,0.05);
						}
						.penggunaan-notice-tabs .ant-tabs-tab:hover {
							border-color: #1e4d8a !important;
						}
						.penggunaan-notice-tabs .ant-tabs-tab .ant-tabs-tab-btn {
							color: #475569;
							font-weight: 600;
							font-size: 13px;
						}
						.penggunaan-notice-tabs .ant-tabs-tab-active {
							background: linear-gradient(135deg, #0f2847, #1e4d8a) !important;
							border-color: transparent !important;
							box-shadow: 0 4px 12px rgba(15,40,71,0.25);
						}
						.penggunaan-notice-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
							color: #fff !important;
						}
						.penggunaan-notice-tabs .ant-tabs-ink-bar {
							display: none;
						}
						@media (max-width: 768.98px) {
							.penggunaan-notice-tabs .ant-tabs-nav-list {
								width: 100%;
								gap: 6px;
							}
							.penggunaan-notice-tabs .ant-tabs-tab {
								flex: 1;
								margin: 0 !important;
								padding: 8px 4px !important;
								justify-content: center;
							}
							.penggunaan-notice-tabs .ant-tabs-tab .ant-tabs-tab-btn {
								font-size: 11px;
							}
						}
					`}</style>
				</Helmet>

				{/* ── FILTER CARD ── */}
				<Card
					style={{ borderRadius: 14, border: 'none', boxShadow: '0 4px 20px rgba(15,40,71,0.13)', marginBottom: 16 }}
					bodyStyle={{ padding: 0 }}
				>
					{/* Header gradient */}
					<div style={{
						background: 'linear-gradient(135deg, #0f2847 0%, #1e4d8a 60%, #0a3d6b 100%)',
						borderRadius: '14px 14px 0 0',
						padding: '20px 28px',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between',
					}}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
							<div style={{
								width: 52, height: 52, borderRadius: 12,
								background: 'rgba(255,255,255,0.15)',
								backdropFilter: 'blur(10px)',
								display: 'flex', alignItems: 'center', justifyContent: 'center',
								fontSize: 24,
							}}>
								<CopyOutlined style={{ color: '#fff' }} />
							</div>
							<div>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>
									Laporan Penggunaan Notice
								</div>
								<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, marginTop: 2 }}>
									Rekap penggunaan & notice rusak per nomor polisi
								</div>
							</div>
						</div>
						{loading ? (
							<Tag color="processing">Memuat...</Tag>
						) : hasData ? (
							<Tag color="success">Data Siap</Tag>
						) : (
							<Tag color="default" style={{ background: 'rgba(255,255,255,0.15)', color: '#fff', border: 'none' }}>
								Pilih filter untuk mulai
							</Tag>
						)}
					</div>
				</Card>

				<Tabs
					className="penggunaan-notice-tabs"
					activeKey={activeTab}
					onChange={(k) => this.setState({ activeTab: k })}
					style={{ marginBottom: 4 }}
					size={isMobile ? 'small' : 'middle'}
				>
					<TabPane tab={<span><TableOutlined /> Detail</span>} key="detail">

					{/* Filter form */}
					<Card
						style={{ borderRadius: 14, border: 'none', boxShadow: '0 4px 20px rgba(15,40,71,0.08)', marginBottom: 16 }}
						bodyStyle={{ padding: '20px 28px' }}
					>
						<Form
							layout="vertical"
							name="fdata"
							onFinish={this.handleSubmit}
							ref={this.formRef}
						>
							<Row gutter={[16, 0]} align="bottom">
								<Col xs={24} sm={12} md={6}>
									<Form.Item label="Kabupaten" name="kabupaten">
										{this.generateSelect("Kabupaten", configClass.apiUrl.kabupaten, "id", "name")}
									</Form.Item>
								</Col>
								<Col xs={24} sm={12} md={6}>
									<Form.Item label="UPT" name="upt">
										{this.generateSelect("Upt", configClass.apiUrl.upt, "id", "nama", "id")}
									</Form.Item>
								</Col>
								<Col xs={24} sm={12} md={6}>
									<Form.Item label="Nomor Polisi" name="nomor_polisi">
										<Input placeholder="Kosongkan untuk semua nopol" />
									</Form.Item>
								</Col>
								<Col xs={24} sm={6} md={3}>
									<Form.Item label="Dari Tanggal" name="mulai_dari_picker">
										<DatePicker
											placeholder="dd-mm-yyyy"
											format="DD-MM-YYYY"
											style={{ width: "100%" }}
											onChange={(_, ds) => this.formRef.current.setFieldsValue({ mulai_dari: ds })}
										/>
									</Form.Item>
									<Form.Item name="mulai_dari" style={{ display: "none" }}>
										<Input type="hidden" />
									</Form.Item>
								</Col>
								<Col xs={24} sm={6} md={3}>
									<Form.Item label="Sampai" name="sampai_dengan_picker">
										<DatePicker
											placeholder="dd-mm-yyyy"
											format="DD-MM-YYYY"
											style={{ width: "100%" }}
											onChange={(_, ds) => this.formRef.current.setFieldsValue({ sampai_dengan: ds })}
										/>
									</Form.Item>
									<Form.Item name="sampai_dengan" style={{ display: "none" }}>
										<Input type="hidden" />
									</Form.Item>
								</Col>
							</Row>
							<div style={{ fontSize: 11, color: '#888', marginBottom: 12 }}>
								* Kosongkan periode untuk default hari ini.
							</div>
							<Row gutter={8}>
								<Col xs={hasData ? 12 : 24} sm="auto">
									<Button
										type="primary"
										htmlType="submit"
										block={isMobile}
										loading={loading}
										icon={<SearchOutlined />}
										style={{
											background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
											border: 'none',
											borderRadius: 8,
											fontWeight: 600,
											height: 38,
										}}
									>
										Proses
									</Button>
								</Col>
								{hasData && (
									<Col xs={12} sm="auto">
										<Button
											block={isMobile}
											icon={<ReloadOutlined />}
											style={{ borderRadius: 8, height: 38 }}
											onClick={() => {
												this.formRef.current.resetFields();
												this.setState({ data: null, filter: '', kabupaten_id: '', listUpt: [] }, () => {
													this.initKabupatenFromCookie();
												});
											}}
										>
											Reset
										</Button>
									</Col>
								)}
							</Row>
						</Form>
					</Card>

					{/* ── LOADING ── */}
				{loading && (
					<Card style={{ borderRadius: 14, border: 'none', boxShadow: '0 4px 20px rgba(15,40,71,0.08)', textAlign: 'center', padding: 48 }}>
						<Spin size="large" />
						<div style={{ marginTop: 16, color: '#888' }}>Memuat laporan...</div>
					</Card>
				)}

				{/* ── RESULT CARD ── */}
				{hasData && !loading && (
					<Card
						style={{ borderRadius: 14, border: 'none', boxShadow: '0 4px 20px rgba(15,40,71,0.08)' }}
						bodyStyle={{ padding: 0 }}
					>
						{/* Strip header */}
						<div style={{
							background: 'linear-gradient(90deg, #f0f4ff 0%, #fff 100%)',
							padding: '14px 24px',
							borderRadius: '14px 14px 0 0',
							borderBottom: '1px solid #e8edf5',
							display: 'flex', alignItems: 'center', justifyContent: 'space-between',
							flexWrap: 'wrap', gap: 8,
						}}>
							<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
								<TableOutlined style={{ color: '#1e4d8a', fontSize: 18 }} />
								<span style={{ fontWeight: 600, color: '#0f2847', fontSize: 15 }}>
									Hasil Laporan
								</span>
								<Tag color="blue">{data.jumlah_nopol} Nomor Polisi</Tag>
								{this.getRedNotices().length > 0 && (
									<Tag color="error" icon={<ExclamationCircleOutlined />}>
										{this.getRedNotices().length} Notice perlu koreksi
									</Tag>
								)}
							</div>
							<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
								<span style={{ fontSize: 12, color: '#888' }}>Cetak :</span>
								<Button
									size="large"
									icon={<PrinterOutlined />}
									style={{
										borderRadius: 8,
										fontWeight: 600,
										borderColor: '#0f2847',
										color: '#0f2847',
										height: 38,
									}}
									onClick={this.checkAndPrint}
								>
									PDF
								</Button>
							</div>
						</div>

						{/* Table */}
						<div style={{ padding: '0 20px 20px', overflowX: 'auto' }}>
							<table className="laporan-table" border="1" cellPadding="5" style={{ width: '100%', marginTop: 16 }}>
								<thead>
									<tr>
										<th rowSpan={2}>No.</th>
										<th rowSpan={2}>Nomor Kendaraan</th>
										<th rowSpan={2}>Tanggal Penetapan</th>
										<th rowSpan={2}>Masa Pajak</th>
										<th colSpan={2}>Nomor Notice</th>
										<th rowSpan={2}>Keterangan</th>
										<th rowSpan={2}>Jumlah</th>
									</tr>
									<tr>
										<th>Terpakai</th>
										<th>Batal/Rusak</th>
									</tr>
								</thead>
								<tbody>
									{(() => {
										return data.data.map((g, gi) => {
											const batalSet = new Set(g.batal_rusak.map(k => k.nomor_notice));
											return (
												<tr key={gi}>
													<td className="teks-tengah">{gi + 1}</td>
													<td className="teks-tengah">{g.nomor_polisi}</td>
													<td className="teks-tengah">{g.tgl_penetapan}</td>
													<td className="teks-tengah">{g.masa_pajak}</td>
													<td className="teks-tengah">
														{g.nomor_notice_terpakai.length === 0 ? '-' : g.nomor_notice_terpakai.map((n, ni) => {
															const isRed = n.rusak || batalSet.has(n.nomor_notice) || globalCount[n.nomor_notice] > 1;
															return (
																<div key={ni} style={isRed ? { color: 'red', fontWeight: 600 } : undefined}>
																	{n.nomor_notice}
																</div>
															);
														})}
													</td>
													<td className="teks-tengah">
														{g.batal_rusak.length === 0 ? '-' : g.batal_rusak.map((k, ki) => (
															<div key={ki}>{k.nomor_notice}</div>
														))}
													</td>
													<td className="teks-tengah">
														{g.batal_rusak.length === 0 ? '-' : g.batal_rusak.map((k, ki) => (
															<div key={ki}>{k.keterangan}</div>
														))}
													</td>
													<td className="teks-kanan">
														{g.nomor_notice_terpakai.filter(n => n.jumlah > 0).map((n, ni) => (
															<div key={'t' + ni} style={{ color: '#52c41a' }}>
																Rp {Number(n.jumlah).toLocaleString('id')}
															</div>
														))}
														{g.batal_rusak.map((k, ki) => (
															<div key={'b' + ki}>Rp {Number(k.jumlah || 0).toLocaleString('id')}</div>
														))}
														{g.nomor_notice_terpakai.filter(n => n.jumlah > 0).length === 0 && g.batal_rusak.length === 0 && '-'}
													</td>
												</tr>
											);
										});
									})()}
								</tbody>
							</table>
						</div>
					</Card>
				)}

					</TabPane>

					<TabPane tab={<span><CalendarOutlined /> {isMobile ? 'Harian' : 'Rekap Harian'}</span>} key="rekap_harian">
						{this._renderRekapTab('rh', {
							dateMode: 'range',
							loading: this.state.rh_loading,
							data: this.state.rh_data,
							onProses: this.getRekapHarian,
							printSelector: '.notice-rekap-harian-print-section',
							judulCetak: 'REKAP HARIAN PENGGUNAAN NOTICE',
						})}
					</TabPane>

					<TabPane tab={<span><BarChartOutlined /> {isMobile ? 'Bulanan' : 'Rekap Bulanan'}</span>} key="rekap_bulanan">
						{this._renderRekapTab('rb', {
							dateMode: 'month',
							loading: this.state.rb_loading,
							data: this.state.rb_data,
							onProses: this.getRekapBulanan,
							printSelector: '.notice-rekap-bulanan-print-section',
							judulCetak: 'REKAP BULANAN PENGGUNAAN NOTICE',
						})}
					</TabPane>
				</Tabs>

				{/* ── WARNING MODAL ── */}
				<Modal
					open={showWarningModal}
					onCancel={() => this.setState({ showWarningModal: false })}
					footer={null}
					width={520}
					centered
					closable
				>
					<div style={{ textAlign: 'center', padding: '8px 0 8px' }}>
						<div style={{
							width: 72, height: 72, borderRadius: '50%',
							background: 'linear-gradient(135deg, #fff1f0, #ffccc7)',
							display: 'flex', alignItems: 'center', justifyContent: 'center',
							margin: '0 auto 16px', fontSize: 32,
						}}>
							<ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />
						</div>
						<div style={{ fontSize: 18, fontWeight: 700, color: '#0f2847', marginBottom: 8 }}>
							Cetak Tidak Dapat Dilakukan
						</div>
						<div style={{ color: '#555', marginBottom: 16, lineHeight: 1.7, fontSize: 13 }}>
							Terdapat <strong style={{ color: '#ff4d4f' }}>{redNoticesList.length} nomor notice</strong> yang
							terdeteksi duplikasi kode dan nomor notice. Cetak laporan hanya bisa dilakukan setelah
							dilakukan <strong>koreksi nomor notice</strong> oleh Kasi Penetapan.
						</div>

						<div style={{
							background: '#fff1f0', border: '1px solid #ffccc7',
							borderRadius: 10, padding: '10px 14px',
							textAlign: 'left', maxHeight: 220, overflowY: 'auto',
							marginBottom: 16,
						}}>
							<div style={{ fontSize: 11, color: '#999', marginBottom: 6, fontWeight: 600 }}>
								DAFTAR NOTICE BERMASALAH
							</div>
							{redNoticesList.map((item, i) => (
								<div key={i} style={{
									display: 'flex', justifyContent: 'space-between',
									alignItems: 'center',
									padding: '5px 0',
									borderBottom: i < redNoticesList.length - 1 ? '1px solid #ffe0de' : 'none',
									fontSize: 12,
								}}>
									<span style={{ color: '#444', fontWeight: 500 }}>{item.nopol}</span>
									<Tag color="error" style={{ margin: 0, fontWeight: 600 }}>{item.nomor_notice}</Tag>
								</div>
							))}
						</div>

						<div style={{ color: '#888', fontSize: 12, marginBottom: 20 }}>
							Kalau nomor ini sebenarnya SALAH dilaporkan rusak (fisiknya baik-baik saja), gunakan menu <strong>Transaksi → Audit Notice Rusak</strong> untuk mencabut catatan rusaknya dulu. Kalau catatan rusaknya memang benar, gunakan <strong>Transaksi → Koreksi Nomor Notice</strong> untuk memperbaiki nomor transaksinya.
						</div>

						<Button
							type="primary"
							style={{
								background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
								border: 'none', borderRadius: 8,
								minWidth: 140, height: 40, fontWeight: 600,
							}}
							onClick={() => this.setState({ showWarningModal: false })}
						>
							Mengerti
						</Button>
					</div>
				</Modal>

				{/* ── EMBEDDED PRINT SECTION ── */}
				{hasData && (
					<div className="notice-penggunaan-print-section" style={{ display: 'none' }}>
						<div className="kertas-laporan">
							{/* Header */}
							<div style={{ textAlign: 'center', marginBottom: 6 }}>
								<div style={{ fontSize: 13, fontWeight: 'bold' }}>BADAN PENDAPATAN DAERAH</div>
								<div style={{ fontSize: 13, fontWeight: 'bold' }}>{kabupatenNama}</div>
								<div style={{ fontSize: 14, fontWeight: 'bold', textDecoration: 'underline', marginTop: 4 }}>
									LAPORAN HARIAN PENGGUNAAN NOTICE
								</div>
							</div>

							{/* Info */}
							<table style={{ marginBottom: 8, fontSize: 12 }}>
								<tbody>
									<tr>
										<td style={{ width: 100 }}>SAMSAT</td>
										<td style={{ paddingRight: 8 }}>:</td>
										<td>{uptNama}</td>
									</tr>
									<tr>
										<td>TANGGAL</td>
										<td>:</td>
										<td>{this.fmtTanggal()}</td>
									</tr>
								</tbody>
							</table>

							{/* Table */}
							{data.data.length > 0 && (
								<table className="laporan-table" border="1" cellPadding="4" style={{ width: '100%', fontSize: 11 }}>
									<thead>
										<tr>
											<th rowSpan={2}>No.</th>
											<th rowSpan={2}>Nomor Kendaraan</th>
											<th rowSpan={2}>Tgl Penetapan</th>
											<th rowSpan={2}>Masa Pajak</th>
											<th colSpan={2}>Nomor Notice</th>
											<th rowSpan={2}>Keterangan</th>
											<th rowSpan={2}>Jumlah</th>
										</tr>
										<tr>
											<th>Terpakai</th>
											<th>Batal/Rusak</th>
										</tr>
									</thead>
									<tbody>
										{data.data.map((g, gi) => {
											const batalSet = new Set(g.batal_rusak.map(k => k.nomor_notice));
											return (
												<tr key={gi}>
													<td className="teks-tengah">{gi + 1}</td>
													<td className="teks-tengah">{g.nomor_polisi}</td>
													<td className="teks-tengah">{g.tgl_penetapan}</td>
													<td className="teks-tengah">{g.masa_pajak}</td>
													<td className="teks-tengah">
														{g.nomor_notice_terpakai.length === 0 ? '-' : g.nomor_notice_terpakai.map((n, ni) => {
															const isRed = n.rusak || batalSet.has(n.nomor_notice) || globalCount[n.nomor_notice] > 1;
															return (
																<div key={ni} style={isRed ? { color: 'red', fontWeight: 600 } : undefined}>
																	{n.nomor_notice}
																</div>
															);
														})}
													</td>
													<td className="teks-tengah">
														{g.batal_rusak.length === 0 ? '-' : g.batal_rusak.map((k, ki) => (
															<div key={ki}>{k.nomor_notice}</div>
														))}
													</td>
													<td className="teks-tengah">
														{g.batal_rusak.length === 0 ? '-' : g.batal_rusak.map((k, ki) => (
															<div key={ki}>{k.keterangan}</div>
														))}
													</td>
													<td className="teks-kanan">
														{g.nomor_notice_terpakai.filter(n => n.jumlah > 0).map((n, ni) => (
															<div key={'t' + ni}>{Number(n.jumlah).toLocaleString('id')}</div>
														))}
														{g.batal_rusak.map((k, ki) => (
															<div key={'b' + ki}>{Number(k.jumlah || 0).toLocaleString('id')}</div>
														))}
														{g.nomor_notice_terpakai.filter(n => n.jumlah > 0).length === 0 && g.batal_rusak.length === 0 && '-'}
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							)}

							{data.data.length === 0 && (
								<div style={{ textAlign: 'center', padding: 20 }}>Tidak ada data pada periode/filter ini.</div>
							)}

							{/* Footer */}
							<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16, fontSize: 12 }}>
								{/* Rekapitulasi */}
								<div style={{ minWidth: 240 }}>
									<div style={{ fontWeight: 'bold', marginBottom: 4, textDecoration: 'underline' }}>REKAPITULASI</div>
									<table>
										<tbody>
											{[
												['1. TERPAKAI', rekap.terpakai, 'Lembar'],
												['2. RUSAK', rekap.rusak, 'Lembar'],
											].map(([label, val, sat]) => (
												<tr key={label}>
													<td style={{ paddingRight: 4 }}>{label}</td>
													<td style={{ paddingRight: 4 }}>:</td>
													<td style={{ textAlign: 'right', paddingRight: 8, minWidth: 30 }}>{val}</td>
													<td>{sat}</td>
												</tr>
											))}
											<tr>
												<td style={{ borderTop: '1px solid #000', fontWeight: 'bold' }}>JUMLAH</td>
												<td style={{ borderTop: '1px solid #000', fontWeight: 'bold' }}>:</td>
												<td style={{ borderTop: '1px solid #000', textAlign: 'right', paddingRight: 8, fontWeight: 'bold' }}>{rekap.jumlah}</td>
												<td style={{ borderTop: '1px solid #000', fontWeight: 'bold' }}>Lembar</td>
											</tr>
											<tr><td colSpan={4} style={{ paddingTop: 6 }}></td></tr>
											<tr>
												<td style={{ paddingRight: 4, color: '#555' }}>BATAL TRANSAKSI</td>
												<td style={{ paddingRight: 4, color: '#555' }}>:</td>
												<td style={{ textAlign: 'right', paddingRight: 8, color: '#555' }}>{rekap.batal}</td>
												<td style={{ color: '#555' }}>Transaksi</td>
											</tr>
										</tbody>
									</table>
									{/* <div style={{ fontSize: 9, color: '#777', marginTop: 4 }}>*) Nomor notice dapat digunakan kembali</div> */}
								</div>

								{/* TTD */}
								{ttd.kanan && (
									<div style={{ textAlign: 'center', minWidth: 220 }}>
										<div>{kabupatenNama}, {moment().format('DD-MM-YYYY')}</div>
										<div style={{ fontWeight: 'bold', textTransform: 'uppercase', marginTop: 2 }}>
											{ttd.kanan.jabatan || 'PETUGAS PENETAPAN KENDARAAN'}
										</div>
										<div style={{ marginTop: 60 }}>
											<u style={{ fontWeight: 'bold' }}>{ttd.kanan.nama}</u>
										</div>
										<div>{ttd.kanan.nip}</div>
									</div>
								)}
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers
}

export default connect(
	mapStateToProps,
	{
		initHandler,
		setConfig,
		ajaxViewHandler,
		ajaxHandler,
	}
)(LapPenggunaanNoticeRusak);
